(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoHover);
  } else {
    initPromoHover();
  }
  
  function initPromoHover() {
    const menuLinks = document.querySelectorAll('[data-collection-url]');
    const promoImage = document.getElementById('promo-image-1');
    
    console.log('=== Promo Hover Debug ===');
    console.log('Menu links:', menuLinks.length);
    console.log('Promo image:', promoImage);
    
    if (!promoImage) {
      console.log('ERROR: Promo image not found');
      return;
    }
    
    const defaultImage = promoImage.src;
    
    const collectionsWithImages = Array.from(menuLinks).filter(link => 
      link.dataset.collectionImage && link.dataset.collectionImage.trim() !== ''
    );
    
    console.log('Collections with images:', collectionsWithImages.length);
    collectionsWithImages.forEach(link => {
      console.log('-', link.textContent.trim());
    });
    
    // Reset to Random
    if (collectionsWithImages.length > 0) {
      const randomCollection = collectionsWithImages[Math.floor(Math.random() * collectionsWithImages.length)];
      promoImage.src = randomCollection.dataset.collectionImage;
      promoImage.srcset = randomCollection.dataset.collectionImage;
      console.log('Initial image set to:', randomCollection.textContent.trim());
    }
    
    // Hover Event
    menuLinks.forEach(link => {
      link.addEventListener('mouseenter', function() {
        const imageUrl = this.dataset.collectionImage;
        
        console.log('HOVER:', this.textContent.trim(), '| Has image:', !!imageUrl);
        
        if (imageUrl && imageUrl.trim() !== '') {
          promoImage.src = imageUrl;
          promoImage.srcset = imageUrl;
          console.log('✅ Image switched to:', this.textContent.trim());
        }
      });
    });
    
    // Return Randowm Image when leave drop down
    const dropdown = document.querySelector('[data-promo-block="1"]');
    if (dropdown) {
      const container = dropdown.closest('details-disclosure');
      if (container) {
        container.addEventListener('mouseleave', function() {
          if (collectionsWithImages.length > 0) {
            const randomCollection = collectionsWithImages[Math.floor(Math.random() * collectionsWithImages.length)];
            promoImage.src = randomCollection.dataset.collectionImage;
            promoImage.srcset = randomCollection.dataset.collectionImage;
            console.log('Reset to random image');
          } else {
            promoImage.src = defaultImage;
            promoImage.srcset = defaultImage;
          }
        });
      }
    }
    
    console.log('=== Promo Hover Initialized ===');
  }
})();
